import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import React, { useCallback, useContext } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyStayUpgradeBenefitsModal from './LandingPageLoyaltyStayUpgradeBenefitsModal'

const image: App.Image = {
  id: 'wfzka1j5ru5d5e7hc9u',
  title: 'Free room upgrades',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgrade(props: Props) {
  const { tier, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyStayUpgradeBenefitsModal
      image={image}
    />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    heading="Upgrade your stay"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Enjoy complimentary room and package upgrades at participating hotels—subject to availability—so you can travel in even more style.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyStayUpgrade
